<script>
	// import FocusLocker from 'focus-locker'
	import { fade, fly } from 'svelte/transition'
  import { createEventDispatcher } from 'svelte'
  import hideShowScroll from 'hide-show-scroll'

	const dispatch = createEventDispatcher()

	export let width = 999
	export let modalStyle = ''

	let container

	// bindings
	let modal

	const closeModal = () => dispatch('close')

	const wrapClick = e => e.target === e.currentTarget && closeModal()

	const onShow = () => {
		// show scrollbars
		dispatch('mount')
		hideShowScroll.show()
	}

	const onClose = () => {
		hideShowScroll.hide()
  }
  
	// trap focus listener
	function trapFocus(e) {
		let isTabPressed = e.keyCode === 9
		if (!isTabPressed) {
			return
		}
		const containerNodes = container.querySelectorAll('*')
		const tabbable = Array.from(containerNodes).filter(n => n.tabIndex >= 0)
		if (tabbable.length) {
			e.preventDefault()
			let index = tabbable.indexOf(document.activeElement)
			index += tabbable.length + (e.shiftKey ? -1 : 1)
			index %= tabbable.length
			tabbable[index].focus()
		}
	}
</script>

<style>
	.svelte-modal-wrap {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		position: fixed;
		background: rgba(0, 0, 0, 0.35);
		z-index: 9999;
		display: flex;
		backface-visibility: hidden;
		overflow: auto;
	}
	.svelte-modal-wrap .main {
		padding: 40px 4%;
		margin: auto;
	}
	.svelte-modal {
		position: relative;
		width: 100%;
		background: #fff;
		transition: transform 0.35s;
		border-radius: 3px;
		box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.25);
		background: linear-gradient(
			#971fc2 2%,
			#6c0094,
			#971fc2,
			#6c0094 98%
		);
		padding: 4px;
	}
	.close-modal {
		background-color: #6c0094;
		color: #fff;
		position: absolute;
		right: -14px;
		top: -14px;
		border-radius: 100%;
		width: 37px;
		height: 37px;
		border: 0;
		transition: background-color 0.2s;
		text-align: left;
		z-index: 1;
	}
	.close-modal:hover {
		background-color: #7f11a7;
	}
	.close-modal:active {
		background-color: #6c0094;
	}
	.close-modal svg {
		position: absolute;
		width: 15px;
		height: 15px;
		fill: #fff;
		top: 11px;
		left: 11px;
	}
	/* .modal-inner {
		padding: 37px 30px;
		background: rgba(255, 255, 255, 0.95);
	} */
	@media (max-width: 600px) {
		/* .svelte-modal {
			border-width: 2px;
		} */
		.close-modal {
			right: -8px;
			top: -8px;
			width: 33px;
			height: 33px;
		}
		.close-modal svg {
			width: 15px;
			height: 15px;
			top: 9px;
			left: 9px;
		}
	}
</style>

<svelte:window
	on:keydown={e => (e.keyCode === 27 ? closeModal() : trapFocus(e))} />

<div
	class="svelte-modal-wrap"
	bind:this={container}
	data-no-panel
	on:click={wrapClick}
	transition:fade={{ duration: 300 }}
	on:introstart={onClose}
	on:outroend={onShow}>
	<div class="main" on:click={wrapClick}>
		<div class="inner-wrap" style={`max-width:${width}px`}>
			<div
				class="svelte-modal"
				style={modalStyle}
				in:fly={{ y: 15 }}
				out:fly={{ y: -15 }}
				bind:this={modal}>
				<button class="close-modal" on:click={closeModal}>
					<svg viewBox="0 0 47.971 47.971">
						<path
							d="M28.228 23.986L47.092 5.122a2.998 2.998 0 0 0 0-4.242 2.998
							2.998 0 0 0-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 0 0-4.242
							0 2.998 2.998 0 0 0 0 4.242l18.865 18.864L.879 42.85a2.998 2.998 0
							1 0 4.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879
							2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 0 0 0-4.242L28.228
							23.986z" />
					</svg>
					<span class="sr-only">Close Modal</span>
				</button>
				<slot />
			</div>
		</div>
	</div>
</div>
